<template>
  <div id="ePlace">
    <div style="padding: 0 0.5rem 0.5rem;">
      <b-button variant="primary" tabindex="98"
        @click="save()"><b-icon icon="check"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>&nbsp;&nbsp;
      <b-button tabindex="99"
        @click="close()"><b-icon icon="x"/>&nbsp;{{$t('message.Close_cmd')}}</b-button>
    </div>
    <div class='well'
      style="margin-bottom:0; position: relative; overflow: auto; max-height: 29rem; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
      <table style="border:2.5px solid; padding:5px; width:100%;" rules="all" cellpadding='5'
        v-if="null != inputData">
        <tbody style="line-height:1.5rem;">
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" style="width:7.5rem;">車位預約單號：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:7rem;">
              {{0 == id? '系統自動產生': inputData.orderno}}
            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">預約單位：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
               {{user.deptId}} {{user.dptnm}}

            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">預約人：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
              {{user.id}} {{user.name}}
            </td>
          </tr>
            <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" style="width:7.5rem;">聯絡分機：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:7rem;">
             <b-form-input placeholder="請輸入聯絡分機" :maxlength="60" v-model="inputData.ordertel" />
            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">聯絡手機：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
              <b-form-input placeholder="請輸入聯絡手機" :maxlength="60" v-model="inputData.orderteL2" />

            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">EMAIL</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
<b-form-input placeholder="請輸入EMAIL" :maxlength="60" v-model="inputData.email" />
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">預約期間：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <table>
                <tr>
                  <td>
                    <b-form-datepicker v-model="tDate[0]" :max="tDate[1]" locale="zh-TW" tabindex="1"
                      :autofocus="true"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                  </td>
                  <td>
                    &nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                  </td>
                  <td>
                    <b-form-datepicker v-model="tDate[1]" :min="tDate[0]" locale="zh-TW" tabindex="2"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                  </td>
                  <td class="ncut-edit-form-text label-td" style="width:7rem;">租借時段</td>
               <td class="ncut-row-selectd" colspan="3">
              <select v-model="inputData.ordstime">
                  <option selected="selected" value="0900">09:00</option>
		<option value="1000">10:00</option>
		<option value="1100">11:00</option>
		<option value="1200">12:00</option>
		<option value="1300">13:00</option>
		<option value="1400">14:00</option>
		<option value="1500">15:00</option>
		<option value="1600">16:00</option>
		<option value="1700">17:00</option>
		<option value="1800">18:00</option>
		<option value="1900">19:00</option>
		<option value="2000">20:00</option>
		<option value="2100">21:00</option>
                  </select>

            </td>~
               <td class="ncut-row-selectd" colspan="3">
              <select v-model="inputData.ordetime">
                <option selected="selected" value="1000">10:00</option>
		<option value="1100">11:00</option>
		<option value="1200">12:00</option>
		<option value="1300">13:00</option>
		<option value="1400">14:00</option>
		<option value="1500">15:00</option>
		<option value="1600">16:00</option>
		<option value="1700">17:00</option>
		<option value="1800">18:00</option>
		<option value="1900">19:00</option>
		<option value="2000">20:00</option>
		<option value="2100">21:00</option>
		<option value="2200">22:00</option>
                  </select>

            </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" tabindex="3">預約場地：</td>
            <td class="ncut-row-selectd" colspan="3">
              <select v-model="inputData.placeno">
                  <option value="" selected>請選擇</option>
	                <option value="1110000">青永館前廣場貴賓停車位14格</option>
	                <option value="1211000">行政大樓1F前廣場停車位4格</option>
	                <option value="1611000">圖書資訊館1F前圓環貴賓停車位9格</option>
	                <option value="2000000">後門草皮臨時停車場90格</option>
	                <option value="2100000">前門草皮臨時停車場150格</option>
                  </select>

            </td>
            <td class="ncut-edit-form-text label-td">預約車位數量：</td>
            <td class="ncut-base-form-ipt text-td" >
              <b-form-input placeholder="請輸入預約車位數量" :maxlength="60" tabindex="3"
                v-model="inputData.mcarnum" />
            </td>

          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">申請事由：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-textarea type="textarea" placeholder="請輸入預約車位說明" tabindex="4"
                :rows="5"
                v-model="inputData.ordermo"/>
            </td>
          </tr>
           <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">其他需求：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-textarea type="textarea" placeholder="請輸入預約車位說明" tabindex="4"
                :rows="5"
                v-model="inputData.otherabs"/>
            </td>
          </tr>
          <template v-if="0 == id?true:false" >
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" tabindex="5" >建立日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ crE_DTE | dateFormatV2   }}</td>
            <td class="ncut-edit-form-text label-td" tabindex="5" >修改日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ moD_DTE | dateFormatV2   }}</td>

          </tr>
          </template>
            <template v-if="0 != id?true:false" >
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" tabindex="5" >建立日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ inputData.crE_DTE | dateFormatV2    }}</td>
            <td class="ncut-edit-form-text label-td" tabindex="5" >修改日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ inputData.moD_DTE  | dateFormatV2   }}</td>

          </tr>
          </template>
          <tr>
            <td class="ncut-edit-form-text ">置頂排序：</td>
            <td class="ncut-base-form-ipt" colspan="5" style="padding: 1rem;">
              <b-form-input id="range-1" v-model="inputData.rankKey" type="range" min="0" max="100" tabindex="6"></b-form-input>
              <div class="mt-2">排序：<font size="+1" style="color:#411c35;">{{ inputData.rankKey }}</font>（預設為 0，可決定報表顯示置頂，數字越大順位越高。）</div>
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">說明：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <div v-html="memo"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool'

export default {
  name: 'ePlace',
  props: [
    'id'
  ],
  data () {
    return {
      isIE: false,
      inputData: null,
      memo: '無',
      crE_DTE: new Date(),
      moD_DTE: new Date(),
      tDate: [null, null]
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {

     setDate (yy, mm, dd) {
        var tYY = parseInt(yy) + 1911;
        var tMM = parseInt(mm) - 1;
        var tDD = parseInt(dd);
        return new Date(tYY, tMM, tDD);
     },
     getDate (dt) {
        var date = null;
        if (null != dt) {
          if (typeof dt == "string") {
              date = new Date(dt);
          } else {
              date = dt;
          }
        }
       var year = date.getFullYear();
       var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1);
       var day = date.getDate() <10 ? '0' + date.getDate() : '' + date.getDate();
        return tools.stringFormat("{0}{1}{2}",year-1911, month, day);
     },
     dateFormatV3: function (input) {
       var d = new Date(input);
       var year = d.getFullYear();
       var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1):(d.getMonth() + 1);
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
       var hh = d.getHours();
       var mm = d.getMinutes();
       var ss = d.getSeconds();
       return  tools.stringFormat("{0}-{1}-{2} {3}:{4}:{5}", year, month, day,hh,mm,ss);
    },
    hideModal (event) {
      this.$emit('hideModal');
    },
    close() {
      this.$emit('hideModal');
    },
    checkSaveData () {
      let msg = '';

      if (tools.isNullOrEmpty(this.inputData.ordermo)) {
        msg = '貴賓車位預約說明';
      }
      return msg;
    },
    save () {
      var msg = this.checkSaveData();
      var moD_DTE1= new Date();
      this.inputData.moD_DTE = this.dateFormatV3(moD_DTE1);
      var crE_DTE1= new Date();
      this.inputData.crE_DTE = this.dateFormatV3(crE_DTE1);
       this.inputData.sysId = this.sysId;
              this.inputData.ORDERID = this.user.id;
              this.inputData.ORDERNA = this.user.name;
              this.inputData.UNIT = this.user.deptId;
              this.inputData.UNITNAME = this.user.dptnm;
      if (0 == msg.length) {
        let vm = this;
        vm.inputData.sysId = vm.sysId;
        vm.inputData.userId = vm.user.id;
        vm.inputData.sdate = vm.getDate(vm.tDate[0]);
        vm.inputData.edate = vm.getDate(vm.tDate[1]);

        this.$http.put('./WebApi/Place/SetPlace', vm.inputData)
          .then((response) => {
            if (0 < response.data) {
                tools.showAlert(vm, 'success', '恭喜您,存檔成功');
                vm.mode = 2;
               // vm.getPlaceData(response.data);
                vm.$store.dispatch('actionReSetFlag2', true);
            }
            else {
                tools.showAlert(vm, 'danger', '對不起,存檔失敗');
            }
          })
          .catch(function (error) {
              tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,請輸入'.concat(msg).concat('!'));
      }
    },
    getPlaceData: function (id) {
      var vm = this
      this.$http.get('./WebApi/Place/GetPlace/'.concat(id))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            console.log(vm.inputData);
            if (!tools.isNullOrEmpty(vm.inputData.sdate)) {
              vm.tDate [0] = vm.setDate(vm.inputData.sdate.substring(0, 3), vm.inputData.sdate.substring(3, 5), vm.inputData.sdate.substring(5, 7));
            }
            if (!tools.isNullOrEmpty(vm.inputData.edate)) {
              vm.tDate [1] = vm.setDate(vm.inputData.edate.substring(0, 3), vm.inputData.edate.substring(3, 5), vm.inputData.edate.substring(5, 7));
            }
            if (0 == vm.inputData.id) {
              var today = new Date();
              var yy = today.getFullYear();
              var mm = today.getMonth();
              var dd =  today.getDate();

               vm.inputData.SysId = vm.SysId;
               vm.inputData.ORDERID = vm.user.id;
              vm.inputData.ORDERNA = vm.user.name;
              vm.inputData.UNIT = vm.user.deptId;
              vm.inputData.UNITNAME = vm.user.dptnm;
              /*vm.inputData.PLACENO = vm.user.PLACENO;
              vm.inputData.sDate = vm.user.SDATE;
              vm.inputData.EDATE = vm.user.EDATE;
              vm.inputData.ORDERTEL = vm.user.ORDERTEL;
              vm.inputData.ORDERTEL2 = vm.user.ORDERTEL2;
              vm.inputData.ORDERMO = vm.user.ORDERMO;
              vm.inputData.MCARNUM = vm.user.MCARNUM;*/
            }
          }
        }
        )
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
      return this.$http
                 .get('./WebApi/Place/GetPlace/'.concat(id));
    },
    getMemoData: function (id) {
      return this.$http
                 .get('./WebApi/Common/GetFormatByNo/'.concat(this.sysId).concat("/1/1"));
    },
  },
  filters: {
    dateFormat:function(input) {
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
       return  year+ '/' + month + '/' + day ;
    },
    dateFormatV2:function(input) {
       var d = new Date(input);
       var year = d.getFullYear();
       var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1):(d.getMonth() + 1);
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
       var hh = d.getHours();
       var mm = d.getMinutes();
       var ss = d.getSeconds();
       return  tools.stringFormat("{0}-{1}-{2} {3}:{4}:{5}", year, month, day,hh,mm,ss);
    }

  },
  created () {
    console.log('======created EditPlaceView =====');
    console.log('editId='  + this.id);
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge") > -1;

    let vm = this;
    this.mode = (this.id == 0? 1: 2);
    this.$http.all([this.getMemoData()])
              .then(vm.$http.spread(function (data1) {
                      if (!tools.isNull(data1)) {
                        vm.data = data1.data
                      }
                      vm.getPlaceData(vm.id);
                    }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
